import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import {
  formatDateTime as i18nFormatDateTime,
  formatRelativeTime as i18nFormatRelativeTime,
} from '@/lib/i18n';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Format a date according to the user's locale
 * @deprecated Use formatDateTime from @/lib/i18n for locale-aware formatting
 */
export function formatDate(date: string | Date): string {
  // Delegate to locale-aware formatter
  return i18nFormatDateTime(date);
}

/**
 * Format a relative time string according to the user's locale
 */
export function formatRelativeTime(date: string | Date): string {
  // Delegate to locale-aware formatter
  return i18nFormatRelativeTime(date);
}

export function truncate(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + '...';
}

export function getStatusColor(status: string): string {
  switch (status) {
    case 'Approved':
      return 'text-green-600 bg-green-50';
    case 'Rejected':
      return 'text-red-600 bg-red-50';
    case 'Pending':
      return 'text-yellow-600 bg-yellow-50';
    default:
      return 'text-gray-600 bg-gray-50';
  }
}

export function getModerationStatusColor(status: string): string {
  switch (status) {
    case 'Clean':
      return 'text-green-600 bg-green-50';
    case 'PreFlagged':
      return 'text-orange-600 bg-orange-50';
    case 'Flagged':
      return 'text-red-600 bg-red-50';
    default:
      return 'text-gray-600 bg-gray-50';
  }
}

export function debounce<T extends (...args: any[]) => any>(
  func: T,
  wait: number
): (...args: Parameters<T>) => void {
  // Derived from setTimeout rather than annotated as NodeJS.Timeout: this runs in
  // the browser, where the handle is a number, and the NodeJS namespace is not in
  // scope without @types/node.
  let timeout: ReturnType<typeof setTimeout>;
  return (...args: Parameters<T>) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
}
